import { render, staticRenderFns } from "./materiales.vue?vue&type=template&id=2543d42c"
import script from "./materiales.vue?vue&type=script&lang=js"
export * from "./materiales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports